import {
  USER_SETUP_REQUEST,
  USER_SETUP_SUCCESS,
  USER_SETUP_FAILURE,
  RESET_USER_SETUP_STATE,
} from "../../actionTypes/userSetup";

export interface UserSetupPayload {
  invitationToken: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneType: string;
  phoneNumber: string;
  role: string;
  password: string;
  confirmPassword: string;
  captchaInput: string;
}

export const userSetupRequest = (params: UserSetupPayload) => {
  return {
    type: USER_SETUP_REQUEST,
    payload: params,
  };
};

export const userSetupSuccess = () => {
  return {
    type: USER_SETUP_SUCCESS,
  };
};

export const userSetupFailure = (error?: string) => {
  return {
    type: USER_SETUP_FAILURE,
    payload: error,
  };
};

export const resetUserSetupState = () => {
  return {
    type: RESET_USER_SETUP_STATE,
  };
};

